export default __webpack_public_path__ + "static/media/tech.6afa2f51.gif";